<template>
  <div class="page not-found">
    <p>Page you are looking for could not be found.</p>
  </div>
</template>

<script>
export default {
  metaInfo: {
    title: 'Not found'
  }
}
</script>
